import React from 'react'
import moment from 'moment'
import DatePicker from 'react-datepicker';
import FileUpload from '../ui/FileUpload'
import Avatar from '../user/Avatar'

import dateSVG from '../therapist/images/calendar.svg'

import './styles/PatientDetailsForms.scss';
import 'react-datepicker/dist/react-datepicker.css';

const PatientDetailsForm = (props) => {

  const canSubmit = (props.patient.firstName && props.patient.firstName !== '' && props.patient.lastName && props.patient.lastName !== '')



  return <div >
    {props.children}
    <form className="patientEdit" onSubmit={(e) => {
      e.preventDefault();
      return false;
    }}>

      <div className="patientNames row">
        {<span className="firstName"><label>First Name</label> <br />
          <input className="md-input md-title"
            autoComplete="off"
            onChange={(e) => props.handleInputChange(e, 'firstName')}
            value={props.patient.firstName}
            type="text" placeholder="First Name" />

        </span>
        }
        {/*!props.hide.middleName && <span className="middleName"><label>Middle Name(s)</label> <br />
          <input className="md-input md-title"
            autoComplete="off"
            onChange={(e) => props.handleInputChange(e, 'middleNames')}
            value={props.patient.middleNames}
            type="text" placeholder="Middle Name(s)" />

        </span>
        */}
        {<span className="lastName"><label>Last Name</label> <br />
          <input className="md-input md-title"
            autoComplete="off"
            onChange={(e) => props.handleInputChange(e, 'lastName')}
            value={props.patient.lastName}
            type="text" placeholder="Last Name" />

        </span>
        }
      </div>

      <div className="dateAndPick row">
        <div className="datePicker">
          <label>Date of Birth</label>
          {/* <img src={dateSVG} /> */}
          <input style={{ backgroundImage: `url(${dateSVG})` }} className="md-input md-title hide"
            autoComplete="off"
            type="date"
            onChange={(e) => props.handleInputChange(e, 'dob')}
            value={moment(props.patient.dob).format('YYYY-MM-DD')}
            placeholder="Date of Birth" />
          <DatePicker
            selected={props.startDate}
            onChange={props.handleChange}
            dateFormat="YYYY/MM/DD"
            // popperModifiers={{
            //   preventOverflow: {
            //     enabled: true,
            //     escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
            //     boundariesElement: 'viewport'
            //   }
            // }}
            showYearDropdown
          />
        </div>
        {<div className="picContainer">
          {props.patient.picture && <Avatar pic={`${props.patient.picture.thumb}&t=${props.update}`} />}
          {props.patient._id && <FileUpload name={`patient_${props.patient._id}`}
            path={`images/patients/${props.patient._id}/`}
            callback={props.handlePatientImage} />}
        </div>
        }
      </div>

      <div className="row">
        <button type="button" disabled={!canSubmit} className="md-button md-raised md-accent right" onClick={e => props.handleSubmit(e)}>
          Save Patient
        </button>
      </div>

    </form>
  </div>
}

PatientDetailsForm.defaultProps = {
  patient: {},
  hide: {},
  handlePatientImage: () => { }
}
export default PatientDetailsForm;



// WEBPACK FOOTER //
// ./src/components/admin/PatientDetailsForm.jsx